import { useEffect, useState } from 'react';

import AnonymousRoundedImage from 'components/atoms/rounded-image/AnonymousRoundedImage';
import UserRoundedImage from 'components/atoms/rounded-image/UserRoundedImage';

import './Notification.scss';
import { NotificationData } from '../../../types/notification';
import { useUserProfile } from '../../../utils/hooks';
import { useNavigate } from 'react-router-dom';
import NotificationService from '../../../services/notificationService';

interface NotificationProps {
  notification: NotificationData;
  onNotificationRead: (notification: NotificationData) => void;
}

function Notification({ notification, onNotificationRead }: NotificationProps) {
  const [messageTitle, setMessageTitle] = useState<string>('');
  const [message, setMessage] = useState<string>('');
  const [link, setLink] = useState<string>('#');

  const actorUserProfile = useUserProfile(notification.actorId);
  const navigate = useNavigate();

  /*  const date = new Date();
  const currentTime = date.getTime();
  //@ts-ignore
  const serverTime = notification.created.toMillis();*/

  useEffect(() => {
    async function fetchData() {
      const [fetchedMessage, fetchedTitle, fetchedLink] = await NotificationService.resolveNotificationText(
        notification
      );
      setMessage(fetchedMessage);
      setMessageTitle(fetchedTitle);
      setLink(fetchedLink);
    }
    fetchData();
  }, [notification]);

  /*  useEffect(() => {
    async function fetchData() {
      if (notification.action === 'NEW_COMMENT_ON_SKILL') {
        if (notification?.object) {
          const userProfile = notification.actorId
            ? await UserProfileApi.getUserProfileByUuid(notification.actorId)
            : null;
          const comment = await CommentApi.getComment(notification.object.id);
          const skill = await SkillApi.getSkillById(comment.contextId);
          if (comment.topLevelCommentId === null) {
            setMessage(
              `${userProfile ? userProfile.firstName : 'An anonymous user'} commented on your skill ${skill.name}`
            );
            setMessageTitle('New comment');
            setLink(`/skills/${skill.slug}#discussion,comment:${comment.id}`);
          }
        }
      } else {
        setMessageTitle('Notification');
        setMessage('You received a notification');
      }
    }
    fetchData();
  }, [notification]);*/

  const timeDifferenceInMinutes = 2; /*Math.round((currentTime - serverTime) / 60000);*/

  let time: string;
  if (timeDifferenceInMinutes < 60) {
    time = `${timeDifferenceInMinutes} min`;
  } else if (timeDifferenceInMinutes / 60 < 24) {
    time = `${Math.round(timeDifferenceInMinutes / 60)} hours`;
  } else {
    time = `${Math.round(timeDifferenceInMinutes / 60 / 24)} days`;
  }

  async function handleClick() {
    if (!notification.read) {
      await onNotificationRead(notification);
    }
    navigate(link);
  }

  return (
    <button onClick={handleClick} className="notification">
      <div className="notification-card-inner">
        {actorUserProfile &&
          (notification.actorId !== null ? (
            <UserRoundedImage className="shrink-0" userProfile={actorUserProfile} />
          ) : (
            <AnonymousRoundedImage className="shrink-0" />
          ))}
        <div className="notification-card-content">
          <div className="notification-content-header">
            <p>{messageTitle}</p>
            <p>{`${time} ago`}</p>
          </div>
          <p className="notification-message">{message}</p>
        </div>
      </div>
    </button>
  );
}

export default Notification;
